<nav class="navbar navbar-light bg-white pl-1 pr-1 pl-lg-4 pr-lg-4" style="border-bottom: 1px solid #DADADA;z-index: 2;    top: 0;
    position: sticky;
    width: 100%; ">
  <div class="d-flex w-100 justify-content-between align-items-center" >

<!--     <div>-->

<!--       <a routerLink="">-->
<!--         <img src="./assets/images/logo.png"  width="50" height="50">-->

<!--       </a>-->

<!--     </div>-->
      <div class="d-flex align-items-center" style="gap: 10px">
         <a routerLink=""><img  height="50" style="border-radius: 100%;" [src]="uniLogo"></a>
         <span class="" style="font-size: 20px;">{{uniName}} </span>
      </div>
<!--    <div class="ml-auto mr-auto" style="width: 500px">-->
<!--      <div class="input-group ">-->
<!--        <div class="input-icons">-->
<!--          <i class="fa fa-search icon">-->
<!--          </i>-->
<!--          <input type="text" #search (keyup)="($event)" class="form-control transparent" placeholder="بحث في الباصات" aria-label="Recipient's username" aria-describedby="basic-addon2">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    
      <div class="dropdown">
        <button class="btn p-0 d-flex align-items-center" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="gap: 10px">
          <img id="dropdownMenuButton" [src]="adminPhoto?adminPhoto:'https://www.w3schools.com/howto/img_avatar.png'" alt="Avatar" class="avatar-circle">
          <span class="d-none d-md-block">{{name}}</span>
        </button>
        <div class="dropdown-menu" style="left: 0!important;" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" (click)="logout()">تسجيل خروج</a>
        </div>
      </div>
  </div>
</nav>